import { render } from "./BFaceCenteredQRAvailablePeriodDisp.vue?vue&type=template&id=a2317894&scoped=true"
import script from "./BFaceCenteredQRAvailablePeriodDisp.vue?vue&type=script&lang=js"
export * from "./BFaceCenteredQRAvailablePeriodDisp.vue?vue&type=script&lang=js"

import "./BFaceCenteredQRAvailablePeriodDisp.vue?vue&type=style&index=0&id=a2317894&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2317894"

export default script